(function () {
  if (window.__kovaeHome) return;
  window.__kovaeHome = true;
  var d = document;
  d.documentElement.classList.add('kv-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  var revealIO = (hasIO && !reduce) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function initReveal(root) {
    each(root, '.kv-reveal, .kv-inview', function (el) {
      if (el.getAttribute('data-kv-seen')) return;
      el.setAttribute('data-kv-seen', '1');
      if (revealIO) revealIO.observe(el); else el.classList.add('is-in');
    });
  }

  function initBA(root) {
    each(root, '[data-kv-ba]', function (ba) {
      if (ba.getAttribute('data-kv-ready')) return;
      ba.setAttribute('data-kv-ready', '1');
      var input = ba.querySelector('input[type="range"]');
      if (!input) return;
      var touched = false;
      var set = function (v) { ba.style.setProperty('--pos', v + '%'); };
      input.addEventListener('input', function () { touched = true; set(input.value); });
      set(input.value);
      if (reduce || !hasIO) return;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 1800;
        function step(ts) {
          if (touched) return;
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var v = 50 + Math.sin(p * Math.PI * 2) * 22;
          input.value = v; set(v);
          if (p < 1) requestAnimationFrame(step); else { input.value = 50; set(50); }
        }
        setTimeout(function () { requestAnimationFrame(step); }, 400);
      }, { threshold: 0.6 });
      io.observe(ba);
    });
  }

  function initTabs(root) {
    each(root, '[data-kv-tabs]', function (w) {
      if (w.getAttribute('data-kv-ready')) return;
      w.setAttribute('data-kv-ready', '1');
      var tabs = w.querySelectorAll('[data-kv-tab]');
      var panels = w.querySelectorAll('[data-kv-panel]');
      Array.prototype.forEach.call(tabs, function (t) {
        t.addEventListener('click', function () {
          Array.prototype.forEach.call(tabs, function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
          Array.prototype.forEach.call(panels, function (p) {
            var on = p.getAttribute('data-kv-panel') === t.getAttribute('data-kv-tab');
            p.hidden = !on;
            if (on) each(p, '.kv-reveal', function (r) { r.classList.add('is-in'); });
          });
        });
      });
    });
  }

  function initSwatches(root) {
    each(root, '[data-kv-swatch]', function (s) {
      if (s.getAttribute('data-kv-ready')) return;
      s.setAttribute('data-kv-ready', '1');
      s.addEventListener('click', function () {
        var card = s.closest('[data-kv-card]');
        if (!card) return;
        var img = card.querySelector('.kv-card__img--main');
        var src = s.getAttribute('data-img');
        if (img && src) { img.removeAttribute('srcset'); img.src = src; }
        each(card, '[data-kv-swatch]', function (x) {
          x.classList.toggle('is-active', x === s);
          x.setAttribute('aria-pressed', x === s ? 'true' : 'false');
        });
      });
    });
  }

  function initVideos(root) {
    each(root, 'video.kv-autoplay', function (v) {
      if (v.getAttribute('data-kv-ready')) return;
      v.setAttribute('data-kv-ready', '1');
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (!hasIO || reduce) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.4 }).observe(v);
    });
  }

  var px = [];
  var ticking = false;
  function initParallax(root) {
    if (reduce) return;
    each(root, '[data-kv-parallax]', function (el) { if (px.indexOf(el) === -1) px.push(el); });
  }
  function updateParallax() {
    ticking = false;
    var vh = window.innerHeight;
    px.forEach(function (el) {
      if (!el.isConnected || !el.parentNode) return;
      var r = el.parentNode.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (p * -6).toFixed(2) + '%,0)';
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking && px.length) { ticking = true; requestAnimationFrame(updateParallax); }
  }, { passive: true });

  function initSticky() {
    var sticky = d.querySelector('.kv-sticky');
    var hero = d.querySelector('.kv-hero');
    if (!sticky || !hero || !hasIO) return;
    if (sticky.getAttribute('data-kv-ready')) return;
    sticky.setAttribute('data-kv-ready', '1');
    var heroVisible = true, endVisible = false;
    var end = d.querySelector('.kv-final');
    var upd = function () { sticky.classList.toggle('is-visible', !heroVisible && !endVisible); };
    new IntersectionObserver(function (e) { heroVisible = e[0].isIntersecting; upd(); }, { threshold: 0.05 }).observe(hero);
    if (end) new IntersectionObserver(function (e) { endVisible = e[0].isIntersecting; upd(); }).observe(end);
  }

  function init(root) {
    root = root || d;
    initReveal(root);
    initBA(root);
    initTabs(root);
    initSwatches(root);
    initVideos(root);
    initParallax(root);
    initSticky();
    updateParallax();
  }

  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', function () { init(d); }); } else { init(d); }
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
